var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebookBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6 7.014h2.002V4.827c0-.913.1-2.348.8-3.26C9.505.65 10.46 0 12.053 0c2.675 0 3.758.39 3.758.39l-.511 3.2s-.89-.26-1.72-.26c-.828 0-1.628.325-1.628 1.108V6.95h3.476l-.255 3.03h-3.22v10.994h-3.95V9.946H6V6.914"
})));
export default SvgFacebookBlack;